import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ILoginRequest, ILoginResponse, IUser } from '../interfaces/auth';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly TOKEN_KEY = 'auth_token';
  private readonly USER_KEY = 'current_user';

  constructor(private http: ApiService) {}

  login(credentials: ILoginRequest): Observable<ILoginResponse> {
    return this.http.post<ILoginResponse>('auth/login', credentials).pipe(
      tap((response) => {
        if (response.success && response.token) {
          this.setToken(response.token);
          this.setUser(response.user);
        }
      })
    );
  }

  getUserById(id: number): Observable<IUser> {
    return this.http.get<IUser>(`auth/users/${id}`);
  }

  logout(): void {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.USER_KEY);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  getCurrentUser(): any {
    const user = localStorage.getItem(this.USER_KEY);
    return user ? JSON.parse(user) : null;
  }

  setUser(user: any): void {
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}
